module.exports = __webpack_public_path__ + "img/Regular Coke Can Coca Cola.5fa114ff.png";